/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { classes, Container } from '@adobe-commerce/elsie/lib';
import { OrdersListProps } from '@/account/types';
import { OrdersListWrapper } from '@/account/components/OrdersListWrapper';

export const OrdersList: Container<OrdersListProps> = ({
  className,
  withHeader,
  minifiedView,
  withThumbnails,
  withFilter,
  ordersInMinifiedView,
  pageSize,
  routeOrdersList,
  routeOrderDetails,
  routeReturnDetails,
  routeTracking,
  routeOrderProduct,
  slots,
}) => {
  return (
    <div
      className={classes(['account-orders-list', className])}
      data-testid="ordersListId"
    >
      <OrdersListWrapper
        className={className}
        withHeader={withHeader}
        minifiedView={minifiedView}
        withThumbnails={withThumbnails}
        withFilter={withFilter}
        ordersInMinifiedView={ordersInMinifiedView}
        pageSize={pageSize}
        routeOrdersList={routeOrdersList}
        routeOrderDetails={routeOrderDetails}
        routeReturnDetails={routeReturnDetails}
        routeTracking={routeTracking}
        routeOrderProduct={routeOrderProduct}
        slots={slots}
      />
    </div>
  );
};
